import { ApiPaths } from 'services/api/apiPaths';
import RedisApiAxiosInstance from '../../services/api/RedisApiAxiosInstance/RedisApiAxiosInstance';
import { LoginPayload } from './auth.types';

export const login = (data?: LoginPayload) => RedisApiAxiosInstance.post(ApiPaths.LOGIN, data);

export const logout = () => RedisApiAxiosInstance.delete(ApiPaths.LOGIN);
